export const ROM_EXTENSIONS = ["gba", "gbc", "gb", "zip", "7z"];

export function fileExtension(name: string): string {
  const dot = name.lastIndexOf(".");
  return dot <= 0 ? "" : name.slice(dot + 1).toLowerCase();
}

export function isRomFile(name: string): boolean {
  return ROM_EXTENSIONS.includes(fileExtension(name));
}

export function romBaseName(romFileName: string): string {
  const dot = romFileName.lastIndexOf(".");
  return dot <= 0 ? romFileName : romFileName.slice(0, dot);
}

// mGBA pairs a battery save with its ROM by base name.
export function saveFileName(romFileName: string): string {
  return `${romBaseName(romFileName)}.sav`;
}

// "Pokemon - Emerald Version (USA, Europe).gba" -> "Pokemon Emerald": drop
// the extension, bracketed region/dump tags, No-Intro catalog numbers,
// separators and the word "Version".
export function displayName(romFileName: string): string {
  const name = romBaseName(romFileName)
    // An Xbox disc is often "<game>.xiso.iso".
    .replace(/\.xiso$/i, "")
    .replace(/\s*[([{][^)\]}]*[)\]}]/g, " ")
    .replace(/^\d{3,4}\s*-\s*/, "")
    .replace(/[_.]+/g, " ")
    .replace(/\s+-\s+/g, " ")
    .replace(/\bversion\b/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return name || romBaseName(romFileName);
}

// mGBA writes slot N of a game to <base>.ssN in the savestate directory.
export function stateFileName(romFileName: string, slot: number): string {
  return `${romBaseName(romFileName)}.ss${slot}`;
}

export function stateSlotOf(name: string): number | null {
  const match = /\.ss(\d{1,3})$/.exec(name);
  return match ? Number(match[1]) : null;
}

export function isSaveFileFor(romFileName: string, name: string): boolean {
  if (name === saveFileName(romFileName)) return true;
  return stateSlotOf(name) !== null && romBaseName(name) === romBaseName(romFileName);
}

export function saveFileLabel(name: string): string {
  const slot = stateSlotOf(name);
  return slot === null ? "Battery save" : `State ${slot}`;
}

export function downloadBytes(fileName: string, bytes: Uint8Array) {
  const blob = new Blob([bytes as BlobPart], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}
